/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonBookingInfoViewBasketPriceBreakdownFromJSON, CommonBookingInfoViewBasketPriceBreakdownToJSON, } from './CommonBookingInfoViewBasketPriceBreakdown';
import { ShoppingBasketValidationErrorFromJSON, ShoppingBasketValidationErrorToJSON, } from './ShoppingBasketValidationError';
import { CommonBookingInfoViewBasketServicePackageFromJSON, CommonBookingInfoViewBasketServicePackageToJSON, } from './CommonBookingInfoViewBasketServicePackage';
import { CommonBookingInfoViewBasketPassengersItemsInnerFromJSON, CommonBookingInfoViewBasketPassengersItemsInnerToJSON, } from './CommonBookingInfoViewBasketPassengersItemsInner';
import { CommonBookingInfoViewBasketBookingItemsInnerFromJSON, CommonBookingInfoViewBasketBookingItemsInnerToJSON, } from './CommonBookingInfoViewBasketBookingItemsInner';
/**
 * @export
 */
export const CommonBookingInfoViewBasketStatusEnum = {
    Open: 'open',
    PaymentProcessing: 'payment_processing',
    Paid: 'paid',
    Expired: 'expired'
};
/**
 * Check if a given object implements the CommonBookingInfoViewBasket interface.
 */
export function instanceOfCommonBookingInfoViewBasket(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function CommonBookingInfoViewBasketFromJSON(json) {
    return CommonBookingInfoViewBasketFromJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bookingItems': json['booking_items'] == null ? undefined : (json['booking_items'].map(CommonBookingInfoViewBasketBookingItemsInnerFromJSON)),
        'id': json['id'],
        'isValid': json['is_valid'] == null ? undefined : json['is_valid'],
        'itemCount': json['item_count'] == null ? undefined : json['item_count'],
        'legacyItems': json['legacy_items'] == null ? undefined : (json['legacy_items'].map(CommonBookingInfoViewBasketBookingItemsInnerFromJSON)),
        'passengersItems': json['passengers_items'] == null ? undefined : (json['passengers_items'].map(CommonBookingInfoViewBasketPassengersItemsInnerFromJSON)),
        'priceBreakdown': json['price_breakdown'] == null ? undefined : CommonBookingInfoViewBasketPriceBreakdownFromJSON(json['price_breakdown']),
        'servicePackage': json['service_package'] == null ? undefined : CommonBookingInfoViewBasketServicePackageFromJSON(json['service_package']),
        'status': json['status'],
        'validationErrors': json['validation_errors'] == null ? undefined : (json['validation_errors'].map(ShoppingBasketValidationErrorFromJSON)),
    };
}
export function CommonBookingInfoViewBasketToJSON(json) {
    return CommonBookingInfoViewBasketToJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'booking_items': value['bookingItems'] == null ? undefined : (value['bookingItems'].map(CommonBookingInfoViewBasketBookingItemsInnerToJSON)),
        'id': value['id'],
        'is_valid': value['isValid'],
        'item_count': value['itemCount'],
        'legacy_items': value['legacyItems'] == null ? undefined : (value['legacyItems'].map(CommonBookingInfoViewBasketBookingItemsInnerToJSON)),
        'passengers_items': value['passengersItems'] == null ? undefined : (value['passengersItems'].map(CommonBookingInfoViewBasketPassengersItemsInnerToJSON)),
        'price_breakdown': CommonBookingInfoViewBasketPriceBreakdownToJSON(value['priceBreakdown']),
        'service_package': CommonBookingInfoViewBasketServicePackageToJSON(value['servicePackage']),
        'status': value['status'],
        'validation_errors': value['validationErrors'] == null ? undefined : (value['validationErrors'].map(ShoppingBasketValidationErrorToJSON)),
    };
}
